import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IFlight } from '../interfaces';
import { FlightMapper } from '../mappers';

export type IGetFlightsRepoResponse = IRepoResponse<200, { data: IFlight[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetFlightsRepo = IRepo<[any], IGetFlightsRepoResponse>;

export const GetFlightsRepoType = Symbol.for('GetFlightsRepo');

@bind(GetFlightsRepoType)
export class GetFlightsRepo implements IGetFlightsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/v2/flights/list', query) });
      if (result.status === 200) {
        const data: IFlight[] = result.data.data.map((item) => FlightMapper.toDomain(item));
        return {
          status: 200 as 200,
          response: {
            data,
            total: result.data.total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);

      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
